import styled from 'styled-components';
import { colors } from 'src/config/colors';
import { typography } from 'src/config/typography';

export const SectionContent = styled.div`
  margin: 0;
  padding: 0;
  font-family: ${typography.fontFamilyDefault};

  & ul {
    list-style-type: none;
    padding-left: 25px;

    & > li:before {
      content: '—';
      color: ${colors.pfp3bis};
      padding-right: 18px;
    }
  }

  & ol {
    padding-left: 20px;

    & ::marker {
      font-family: ${typography.fontFamilyHeaders};
      color: ${colors.pfp3bis};
    }

    & > li {
      padding-left: 35px; // ol's 20px + 15px to even the space to the ul's text
    }
  }
`;
